import React from 'react';
import { IChartCardRightProps } from '.';
import { BinaryStackedChart } from '..';

const BinaryRight: React.FC<IChartCardRightProps> = ({ helper }) => (
  <>
    <div className="flex justify-between mb3">
      <p className="f7 fw5 mt0 mb1">most frequent entry: {helper.mostFrequentBinary()}</p>
      <p className="f7 fw5 mt0 mb1">{helper.measurementCount} entries</p>
    </div>
    <BinaryStackedChart range={helper.range} data={helper.dataForBinaryBar()} short={true} />
  </>
);

export default BinaryRight;
